// "use client";
// import React from "react";
// import styles from "./ActionsSidebar.module.css";

// function ActionsSidebar() {
//   return (
//     <div className={styles.sidebarContainer}>
//       <div className={styles.buttonContainer}>
//         <button className={styles.actionButton}>
//           <img
//             src="https://cdn.builder.io/api/v1/image/assets/TEMP/81d8b3dadb4befff8fe982439cb5e0bfd900f1659f1d842004634d6f6402a3cc?placeholderIfAbsent=true"
//             className={styles.buttonIcon}
//           />
//           <span className={styles.buttonText}>Upload Files</span>
//         </button>

//         <button className={styles.actionButton}>
//           <img
//             src="https://cdn.builder.io/api/v1/image/assets/TEMP/58f5cc2218c1da98bef8b8a7795a24e82e5164d0fabaf129466feb2f2ba6bcc3?placeholderIfAbsent=true"
//             className={styles.buttonIcon}
//           />
//           <span className={styles.buttonText}>Create Resume</span>
//         </button>

//         <button className={styles.actionButton}>
//           <img
//             src="https://cdn.builder.io/api/v1/image/assets/TEMP/41109c22e4b2aff2f13fa0a293fbbd0af1c84c815d227bf0b35601c58b6c6008?placeholderIfAbsent=true"
//             className={styles.buttonIcon}
//           />
//           <span className={styles.buttonText}>Generate Resume</span>
//         </button>

//         <button className={`${styles.actionButton} ${styles.activeButton}`}>
//           <img
//             src="./vector.png"
//             className={styles.buttonIcon}
//           />
//           <span className={styles.buttonText}>Create Video</span>
//         </button>

//         <button className={styles.actionButton}>
//           <img
//             src="https://cdn.builder.io/api/v1/image/assets/TEMP/2b4777444e26508d2542e0fc33b719b282e0a0f24bf54f200958630eda48f149?placeholderIfAbsent=true"
//             className={styles.buttonIcon}
//           />
//           <span className={styles.buttonText}>Create Audio</span>
//         </button>
//       </div>
//     </div>
//   );
// }

// export default ActionsSidebar;

// "use client";
// import React, { useState } from "react";
// import styles from "./ActionsSidebar.module.css";

// function ActionsSidebar() {
//   const [activeIndex, setActiveIndex] = useState(null);

//   const buttons = [
//     { text: "Upload Files", icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/81d8b3dadb4befff8fe982439cb5e0bfd900f1659f1d842004634d6f6402a3cc" },
//     { text: "Create Resume", icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/58f5cc2218c1da98bef8b8a7795a24e82e5164d0fabaf129466feb2f2ba6bcc3" },
//     { text: "Generate Resume", icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/41109c22e4b2aff2f13fa0a293fbbd0af1c84c815d227bf0b35601c58b6c6008" },
//     { text: "Create Video", icon: "/vector.png" },
//     { text: "Create Audio", icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/2b4777444e26508d2542e0fc33b719b282e0a0f24bf54f200958630eda48f149" }
//   ];

//   return (
//     <div className={styles.sidebarContainer}>
//       <div className={styles.buttonContainer}>
//         {buttons.map((btn, index) => (
//           <button
//             key={index}
//             className={`${styles.actionButton} ${activeIndex === index ? styles.activeButton : ""}`}
//             onClick={() => setActiveIndex(index)}
//           >
//             <img src={btn.icon} className={styles.buttonIcon} alt={btn.text} />
//             <span className={styles.buttonText}>{btn.text}</span>
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default ActionsSidebar;

"use client";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Stack } from "@/components/ui/layout";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

function ActionsSidebar() {
  const navigate = useNavigate(); // ✅ Initialize navigation function

  // ✅ Define buttons with paths
  const buttons = [
    { text: "Upload Files", icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/81d8b3dadb4befff8fe982439cb5e0bfd900f1659f1d842004634d6f6402a3cc", path: "/upload" },
    { text: "Create Resume", icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/58f5cc2218c1da98bef8b8a7795a24e82e5164d0fabaf129466feb2f2ba6bcc3", path: "/crr" },
    { text: "Generate Resume", icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/41109c22e4b2aff2f13fa0a293fbbd0af1c84c815d227bf0b35601c58b6c6008", path: "/generate-resume" },
    { text: "Create Video", icon: "/Vector.png", path: "/video" }, // ✅ This should be active initially
    { text: "Create Audio", icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/2b4777444e26508d2542e0fc33b719b282e0a0f24bf54f200958630eda48f149", path: "/audio" }
  ];

  // ✅ Find the default active index (where text is "Create Video")
  const defaultActiveIndex = buttons.findIndex((btn) => btn.text === "Create Video");
  const [activeIndex, setActiveIndex] = useState(defaultActiveIndex);

  // ✅ Ensure navigation happens on the first render
  useEffect(() => {
    if (defaultActiveIndex !== -1) {
      navigate(buttons[defaultActiveIndex].path);
    }
  }, [navigate, defaultActiveIndex]);

  return (
    <Card className={cn("h-full")}>
      <CardContent className="p-4">
        <Stack spacing="sm">
          {buttons.map((btn, index) => (
            <Button
              key={index}
              variant={activeIndex === index ? "default" : "ghost"}
              className={cn("w-full justify-start")}
              onClick={() => {
                setActiveIndex(index);
                navigate(btn.path);
              }}
            >
              <img src={btn.icon} className="w-5 h-5 mr-2" alt={btn.text} />
              <span>{btn.text}</span>
            </Button>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
}

export default ActionsSidebar;
